import { render, staticRenderFns } from "./EmailTemplate.vue?vue&type=template&id=52ad39b0&scoped=true&"
import script from "./EmailTemplate.vue?vue&type=script&lang=js&"
export * from "./EmailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplate.vue?vue&type=style&index=0&id=52ad39b0&lang=scss&scoped=true&"
import style1 from "./EmailTemplate.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./EmailTemplate.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ad39b0",
  null
  
)

export default component.exports